import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef } from 'react';
import { Icon } from '../../../../icon';
import { SearchInput } from '../../search/search-input';
import { DropdownContextInstance } from '../types/context';
// TODO: Move these icons into global configuration rather than hard coding values. #286518
const defaultClearIcon = 'cross';
const dropdownSearchKeys = ['text'];
const b = bemClassBuilder('v-dropdown-search-input');
const DropdownSearchInputBase = (props, ref) => {
    const { enableClearIcon, className, placeholder, onComponentWillUnmount } = props;
    const searchInputRef = useRef(null);
    const { searchTerm, options, onSearchTermChanged, onSearchResultsChanged } = useContext(DropdownContextInstance);
    useImperativeHandle(ref, () => ({
        focus: () => { var _a; return (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
        setSearchTerm: term => { var _a; return (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.setSearchTerm(term); }
    }));
    useEffect(() => {
        var _a;
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const clearSearchTerm = async (_e) => {
        var _a;
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.setSearchTerm('');
    };
    const ariaAttributes = Object.assign(Object.assign({}, props.ariaAttributes), { 'aria-autocomplete': 'list' });
    const showClearIcon = enableClearIcon && searchTerm.length > 0;
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [_jsx(SearchInput, { placeholder: placeholder, searchValues: options, searchKeys: dropdownSearchKeys, onResultsChanged: onSearchResultsChanged, onSearchTermChanged: onSearchTermChanged, ariaAttributes: ariaAttributes, onComponentWillUnmount: onComponentWillUnmount, ref: searchInputRef, className: b.element('input', { enableClearIcon }) }), showClearIcon && (_jsx("div", Object.assign({ className: b.element('icon-button', { type: 'clear' }), onClick: clearSearchTerm }, { children: _jsx(Icon, { className: b.element('icon'), name: defaultClearIcon }) })))] })));
};
export const DropdownSearchInput = observer(forwardRef(DropdownSearchInputBase));
DropdownSearchInput.displayName = 'DropdownSearchInput';
